import React, {useContext} from 'react';
import {DataContext} from "../Content/Data";
import TemplateMusic from "./TemplateMusic";

export const Music2 = () => {
    const [data, setData] = useContext(DataContext);

    const addNewElement = (file) => {
        const newEl = {
            name: file.name,
            src: URL.createObjectURL(file),
            id: `drop${Math.random()}`,
            path: ''
        };

        setData({...data, Music: [...data.Music, newEl] });
    }

    return (
        <TemplateMusic
            id={`Music2`}
            data={data.Music}
            addNewElement={addNewElement}
        />
    )
}